import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

const withJwtToken = (to, from, next) => {
  if (localStorage.getItem('jwtToken')) {
    next()
    return
  };
  next('/signin')
}

const withoutJwtToken = (to, from, next) => {
  if (!localStorage.getItem('jwtToken')) {
    next()
    return
  };
  next('/')
}

const onlyAdmin = (to, from, next) => {
  if (localStorage.getItem('role') == 'admin' && localStorage.getItem('jwtToken')) {
    next()
    return
  };
  next('/stat')
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/signin',
      name: 'signin',
      component: () => import('@/views/signinView'),
      beforeEnter: withoutJwtToken
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/usersView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/bonuses',
      name: 'bonuses',
      component: () => import('@/views/bonusesView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/problems',
      name: 'problems',
      component: () => import('@/views/problemsView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/questions',
      name: 'questions',
      component: () => import('@/views/questionsView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/views/adminsView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/ordersView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/purchases',
      name: 'purchases',
      component: () => import('@/views/purchasesView')
    },
    {
      path: '/kontrollers',
      name: 'kontrollers',
      component: () => import('@/views/kontrollersView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: () => import('@/views/ticketsView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/tickets/:id',
      name: 'tickets',
      props: true,
      component: () => import('@/views/ticketsView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/promocodes',
      name: 'promocodes',
      component: () => import('@/views/promocodesView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/groups',
      name: 'groups',
      component: () => import('@/views/groupsView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/config',
      name: 'config',
      component: () => import('@/views/configView'),
      beforeEnter: onlyAdmin
    },
    {
      path: '/stat',
      name: 'stat',
      component: () => import('@/views/statView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/programs',
      name: 'programs',
      component: () => import('@/views/programsView'),
      beforeEnter: withJwtToken
    },
    {
      path: '/termsofuse',
      name: 'termsofuse',
      component: () => import('@/views/termsOfUseView')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('@/views/eventsView')
    },
    {
      path: '*',
      redirect: '/stat'
    }
  ]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    store.dispatch('loadStart')
  }
  next()
})

router.afterEach((to, from) => {
  store.dispatch('loadDone')
})

export default router
